// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx"
    /* webpackChunkName: "component---src-pages-404-tsx" */
    );
  },
  "component---src-pages-contact-tsx": function componentSrcPagesContactTsx() {
    return import("./../../src/pages/contact.tsx"
    /* webpackChunkName: "component---src-pages-contact-tsx" */
    );
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx"
    /* webpackChunkName: "component---src-pages-index-tsx" */
    );
  },
  "component---src-pages-showreel-2021-tsx": function componentSrcPagesShowreel2021Tsx() {
    return import("./../../src/pages/showreel/2021.tsx"
    /* webpackChunkName: "component---src-pages-showreel-2021-tsx" */
    );
  },
  "component---src-pages-showreel-2022-tsx": function componentSrcPagesShowreel2022Tsx() {
    return import("./../../src/pages/showreel/2022.tsx"
    /* webpackChunkName: "component---src-pages-showreel-2022-tsx" */
    );
  },
  "component---src-pages-showreel-index-tsx": function componentSrcPagesShowreelIndexTsx() {
    return import("./../../src/pages/showreel/index.tsx"
    /* webpackChunkName: "component---src-pages-showreel-index-tsx" */
    );
  },
  "component---src-pages-terms-of-service-tsx": function componentSrcPagesTermsOfServiceTsx() {
    return import("./../../src/pages/terms-of-service.tsx"
    /* webpackChunkName: "component---src-pages-terms-of-service-tsx" */
    );
  },
  "component---src-pages-wallpaper-tsx": function componentSrcPagesWallpaperTsx() {
    return import("./../../src/pages/wallpaper.tsx"
    /* webpackChunkName: "component---src-pages-wallpaper-tsx" */
    );
  },
  "component---src-pages-work-ambiental-tsx": function componentSrcPagesWorkAmbientalTsx() {
    return import("./../../src/pages/work/ambiental.tsx"
    /* webpackChunkName: "component---src-pages-work-ambiental-tsx" */
    );
  },
  "component---src-pages-work-animation-tsx": function componentSrcPagesWorkAnimationTsx() {
    return import("./../../src/pages/work/animation.tsx"
    /* webpackChunkName: "component---src-pages-work-animation-tsx" */
    );
  },
  "component---src-pages-work-branding-tsx": function componentSrcPagesWorkBrandingTsx() {
    return import("./../../src/pages/work/branding.tsx"
    /* webpackChunkName: "component---src-pages-work-branding-tsx" */
    );
  },
  "component---src-pages-work-development-tsx": function componentSrcPagesWorkDevelopmentTsx() {
    return import("./../../src/pages/work/development.tsx"
    /* webpackChunkName: "component---src-pages-work-development-tsx" */
    );
  },
  "component---src-pages-work-illustration-tsx": function componentSrcPagesWorkIllustrationTsx() {
    return import("./../../src/pages/work/illustration.tsx"
    /* webpackChunkName: "component---src-pages-work-illustration-tsx" */
    );
  },
  "component---src-pages-work-index-tsx": function componentSrcPagesWorkIndexTsx() {
    return import("./../../src/pages/work/index.tsx"
    /* webpackChunkName: "component---src-pages-work-index-tsx" */
    );
  },
  "component---src-pages-work-integrated-tsx": function componentSrcPagesWorkIntegratedTsx() {
    return import("./../../src/pages/work/integrated.tsx"
    /* webpackChunkName: "component---src-pages-work-integrated-tsx" */
    );
  },
  "component---src-pages-work-video-tsx": function componentSrcPagesWorkVideoTsx() {
    return import("./../../src/pages/work/video.tsx"
    /* webpackChunkName: "component---src-pages-work-video-tsx" */
    );
  },
  "component---src-pages-work-web-mobile-tsx": function componentSrcPagesWorkWebMobileTsx() {
    return import("./../../src/pages/work/web-mobile.tsx"
    /* webpackChunkName: "component---src-pages-work-web-mobile-tsx" */
    );
  }
};